module.exports = __webpack_public_path__ + "img/cp6_02.9f556c5e.jpg";